module.exports = __webpack_public_path__ + "static/media/list.77b402af.txt";